import {generateStegHeaderRef} from "./common";

export const focusOnSteg = id => {
    const node = document.getElementById(generateStegHeaderRef(id));
    node && node.focus();
    node && node.scrollIntoView({behavior: "smooth"})
};